import {
    Chip,
    ChipPropsColorOverrides,
    Stack,
    Typography,
} from "@mui/material";
import { OverridableStringUnion } from "@mui/types";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

import { ApprovalDataChangeAction } from "types/ApprovalDataChangeSet";

export interface ApprovalDataChangeSetEntityActionDataTitleProps {
    entity: string;
    action: ApprovalDataChangeAction;
    changeCount: number;
}

export function ApprovalDataChangeSetEntityActionDataTitle(
    props: ApprovalDataChangeSetEntityActionDataTitleProps,
) {
    let chipIcon = <QuestionMarkIcon />;
    let chipColor: OverridableStringUnion<
        | "default"
        | "primary"
        | "secondary"
        | "error"
        | "info"
        | "success"
        | "warning",
        ChipPropsColorOverrides
    > = "default";

    switch (props.action) {
        case ApprovalDataChangeAction.Inserted:
            chipIcon = <AddIcon fontSize="small" />;
            chipColor = "success";
            break;

        case ApprovalDataChangeAction.Updated:
            chipIcon = <EditIcon fontSize="small" />;
            chipColor = "warning";
            break;

        case ApprovalDataChangeAction.Deleted:
            chipIcon = <DeleteIcon fontSize="small" />;
            chipColor = "error";
            break;
    }

    return (
        <Stack direction={"row"}>
            <Chip
                icon={chipIcon}
                color={chipColor}
                label={
                    <>
                        <Typography
                            component={"span"}
                            variant={"inherit"}
                            fontWeight={"bold"}
                        >
                            {props.entity}
                        </Typography>
                        : {props.action} data ({props.changeCount} changes)
                    </>
                }
            />
        </Stack>
    );
}
